<div class="dp-scope" role="group" aria-label="What is anonymized">
  @for (option of options; track option) {
  <div class="form-check mb-1">
    <input type="checkbox" class="form-check-input" [id]="idPrefix() + '-' + option.value"
           [checked]="isChecked(option)" [disabled]="disabled() || option.locked"
           (change)="toggle(option, $any($event.target).checked)">
    <label class="form-check-label" [for]="idPrefix() + '-' + option.value">{{ option.label }}</label>
  </div>
  }
</div>
